import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5d97eba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 환급 신청은 이런 과정을 통해 진행 됩니다. ")

import { ref, onMounted } from 'vue'

import Text from '@/components/common/TextComponent.vue'
import { FONT_WEIGHT } from '@/styles/variables'
import RefundProcess from '@/styles/icon/RefundProcess.vue'

import { setAnimationObserver } from '../libs/observer'


export default /*#__PURE__*/_defineComponent({
  name: 'LandingProcess',
  setup(__props) {

const wrapper = ref()
const showAnimation = ref(false)

onMounted(() => {
  setAnimationObserver(wrapper.value, () => { showAnimation.value = true }, 0.2)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapper",
    ref: wrapper,
    class: "wrapper"
  }, [
    _createVNode(Text, {
      class: _normalizeClass(["text animation-show", { show: showAnimation.value }]),
      size: "64px",
      "mobile-size": "30px",
      "line-height": "1.25",
      weight: _unref(FONT_WEIGHT).bold,
      "text-align": "center",
      "word-break": "keep-all",
      width: "800px",
      "mobile-width": "308px"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["weight", "class"]),
    _createVNode(RefundProcess, {
      class: _normalizeClass(["animation-show delay", { show: showAnimation.value }])
    }, null, 8, ["class"])
  ], 512))
}
}

})